import { render, staticRenderFns } from "./users-transcriptions-charts.vue?vue&type=template&id=40fb521a&scoped=true&lang=pug&"
import script from "./users-transcriptions-charts.vue?vue&type=script&lang=ts&"
export * from "./users-transcriptions-charts.vue?vue&type=script&lang=ts&"
import style0 from "./users-transcriptions-charts.vue?vue&type=style&index=0&id=40fb521a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fb521a",
  null
  
)

export default component.exports